module.exports = __webpack_public_path__ + "static/media/voucher.1a769d97.svg";